export const environment = {
    production: true,
    API_URL:"https://app-stuat-stdigital-sf-svc.azurewebsites.net/api",
    GOOGLE_MAP_KEY:"AIzaSyCzVT_pP6jOQp9_0iBgqfgu5mw1gDNK66s",
    googleAnalytic:'',
    googleAnalyticKey:''
  };